import type { RouteLocationRaw } from 'vue-router';
import { useAccountStore } from '@/stores/account';
import { canViewAdditionalAccountsManagement } from '@/shared/additionalAccounts/utils/additionalAccountsAccess.util';

/**
 * Restringe la gestión de cuentas adicionales a los niveles con acceso de
 * lectura (ML-5: 2, 3 y 4). El kill-switch `feature_multi_accounts_b2b` se
 * declara en `meta.flag` de la ruta y lo resuelve el guard global
 * `validateFirebaseFeatureFlags` — mismo flag que ya gatea el tab equivalente
 * del Home (`useHomeAccountTabs.ts`); no se repite acá.
 *
 * Crear/Editar/Eliminar NO se gatean acá: son nivel 4 y se resuelven dentro de
 * la página con `canManageAdditionalAccounts`, para que un nivel 2 o 3 pueda
 * entrar y consultar su tabla.
 */
export function additionalAccountsLevelGuard(): RouteLocationRaw | boolean {
  const accountStore = useAccountStore();

  if (!canViewAdditionalAccountsManagement(accountStore.getLevel)) {
    return { name: 'forbidden' };
  }

  return true;
}
